<template>
  <div class="flex rounded-lg gap-2">
    <img
      src="@/assets/icons/rewind.png"
      class="h-12 w-12 cursor-pointer hover:scale-95 transition duration-300"
      @click="doubleBack"
    />
    <img
      src="@/assets/icons/left.png"
      class="h-12 w-12 cursor-pointer hover:scale-95 transition duration-300"
      @click="back"
    />
    <div class="w-[40px] flex items-center">
      <p class="m-auto text-2xl">{{ currentPage }}</p>
    </div>
    <img
      src="@/assets/icons/left.png"
      class="h-12 w-12 rotate-180 cursor-pointer hover:scale-95 transition duration-300"
      @click="nextPage"
    />
    <img
      src="@/assets/icons/rewind.png"
      class="h-12 w-12 rotate-180 cursor-pointer hover:scale-95 transition duration-300"
      @click="doubleNextPage"
    />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  emits: ["update:modelValue"],
  props: {
    pages: Number,
    currentPage: Number,
  },
  methods: {
    back() {
      if (this.currentPage > 1)
        this.$emit("update:modelValue", this.currentPage - 1);
    },
    doubleBack() {
      if (this.currentPage > 2)
        this.$emit("update:modelValue", this.currentPage - 2);
    },
    nextPage() {
      if (this.currentPage < this.pages)
        this.$emit("update:modelValue", this.currentPage + 1);
    },
    doubleNextPage() {
      if (this.currentPage + 2 < this.pages)
        this.$emit("update:modelValue", this.currentPage + 2);
    },
  },
};
</script>
